import { PageContainer } from "components/core/basic/PageContainer";
import HarvestingRules from "./advertising/HavestingRules";
import { DatesProvider } from "dates/DatesContext";

const HarvestingRulesView = () => {
  return (
    <DatesProvider>
      <PageContainer>
        <HarvestingRules />
      </PageContainer>
    </DatesProvider>
  );
};

export default HarvestingRulesView;
